import React, { Component } from "react";

// CSS
import "../../styles/newDesign.scss";
import "./About.scss";

// Components
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

// Helper
import { resolveTenant } from "../../Helper/Api";

// Properties
const properties = require("../../properties.json");

// Fully static, by the teacher's own request -- exact bio content from the reference design
// mockup he sent, not wired to any backend field (unlike Gallery/Contact, this page doesn't need
// to differ per teacher yet).
const SECTIONS = [
  {
    icon: "🏛",
    title: "Academic",
    sub: "Mansoura University",
    text:
      "Full-time Teaching Assistant in the Architecture Department, Faculty of Fine Arts, Mansoura University, and currently pursuing a Master's degree at the Faculty of Engineering, Mansoura University. Architectural Designer at Kerrnel, working across architectural design, digital modeling, and design development, with a focus on translating concepts into precise architectural outcomes.",
  },
  {
    icon: "🦏",
    title: "Rhino & Grasshopper Instructor",
    sub: "Workshops & training",
    text: "Delivering workshops and practical training focused on digital modeling, computational thinking, and advanced design workflows.",
  },
  {
    icon: "🎬",
    title: "Art Direction Workshops",
    sub: "Visual storytelling",
    text: "Conducting Art Direction workshops focused on architectural visualization, visual storytelling, composition, atmosphere, and developing a strong visual identity for architectural projects.",
  },
  {
    icon: "🧬",
    title: "Parametric & Computational Design",
    sub: "Research interest",
    text: "Exploring how geometry, algorithms, and design logic can generate and develop complex architectural forms.",
  },
  {
    icon: "🖨",
    title: "Digital Fabrication",
    sub: "International workshops",
    text: "Participated in international workshops covering Rhino, Parametric Design, and 3D Concrete Printing -- exploring the connection between computational design and emerging fabrication technologies.",
  },
];

// In order: hero photo, then one per SECTIONS entry above -- matches the 6 photos the teacher
// provided (E:\USB Drive\صور الموقع\03-about\01..06).
const PHOTOS = [
  "/assets/about/01.jpeg",
  "/assets/about/02.jpeg",
  "/assets/about/03.png",
  "/assets/about/04.png",
  "/assets/about/05.png",
  "/assets/about/06.png",
];

class About extends Component {
  state = {
    tenant: null,
    notFound: false,
  };

  componentDidMount() {
    resolveTenant()
      .then((tenant) => {
        document.title = tenant.name ? `About ${tenant.name}` : properties.site_name;
        this.setState({ tenant });
      })
      .catch(() => this.setState({ notFound: true }));
  }

  render() {
    const { tenant, notFound } = this.state;

    if (notFound) {
      return (
        <div className="page">
          <div className="container text-center">
            <p>No page was found for this domain.</p>
          </div>
        </div>
      );
    }

    if (!tenant) return null;

    return (
      <>
        <Header tenant={tenant} />

        <div className="nd-page">
          <div className="nd-section nd-wrap">
            <div className="about-hero">
              <div className="about-text">
                <div className="nd-eyebrow">About Me</div>
                <h1>Ahmed Amer</h1>
                <div className="role">Architectural Designer</div>
              </div>
              <div
                className="photo-slot has-photo"
                style={{ backgroundImage: `url(${PHOTOS[0]})` }}
              ></div>
            </div>

            {SECTIONS.map((section, i) => (
              <div className={`about-section ${i % 2 === 1 ? "reverse" : ""}`} key={section.title}>
                <div className="about-text">
                  <div className="r-icon">{section.icon}</div>
                  <h3>{section.title}</h3>
                  <div className="r-sub">{section.sub}</div>
                  <p>{section.text}</p>
                </div>
                <div
                  className="about-media photo-slot has-photo"
                  style={{ backgroundImage: `url(${PHOTOS[i + 1]})` }}
                ></div>
              </div>
            ))}

            <div className="approach">
              <div className="nd-eyebrow">My Approach</div>
              <p>
                I believe Rhino is more than a modeling tool. It is a design environment that
                connects architectural thinking, computational logic, visual direction, and
                digital fabrication.
              </p>
              <div className="tag">Design. Compute. Create.</div>
            </div>
          </div>
        </div>

        <Footer tenant={tenant} />
      </>
    );
  }
}

export default About;
